const toCamelCase = (str) =>
  str
    .replace(/[_-]/g, ' ')
    .replace(
      /(?:^\w|[A-Z]|\b\w)/g,
      (letter, index) => (index === 0 ? letter.toLowerCase() : letter.toUpperCase()),
    )
    .replace(/\s+/g, '');

export const atName = (...args) =>
  `at-${args
    .map((i) => toCamelCase(i))
    .filter((i) => i.length > 0)
    .join('-')}`;

export default atName;



// WEBPACK FOOTER //
// ./src/common/utils/atName.js